import type { FunctionComponent } from 'preact'

interface PickerButtonProps {
  label: string
  reading: boolean
  disabled?: boolean
  onClick: () => void
}

/** The "Vælg …" trigger for a hidden native file input, with its reading spinner. */
export const PickerButton: FunctionComponent<PickerButtonProps> = ({
  label,
  reading,
  disabled,
  onClick,
}) => (
  <button
    type="button"
    class="syv-button syv-button-secondary syv-file-trigger"
    disabled={disabled || reading}
    onClick={onClick}
  >
    {reading ? (
      <>
        <span class="syv-spinner" /> Uploader…
      </>
    ) : (
      label
    )}
  </button>
)
